export default {
  argentina: 'Argentina',
  spain: 'España',
  unitedStates: 'Estados Unidos',
  peru: 'Perú',
  uruguay: 'Uruguay',
  mexico: 'México',
  colombia: 'Colombia',
  other: 'Otro'
}

export const en = {
  argentina: 'Argentina',
  spain: 'Spain',
  unitedStates: 'United States',
  peru: 'Peru',
  uruguay: 'Uruguay',
  mexico: 'Mexico',
  colombia: 'Colombia',
  other: 'Other'
}

export const ca = {
  argentina: 'Argentina',
  spain: 'Espanya',
  unitedStates: 'Estats Units',
  peru: 'Perú',
  uruguay: 'Uruguai',
  mexico: 'Mèxic',
  colombia: 'Colòmbia',
  other: 'Un altre'
}
